import { Tooltip } from "@mui/material";
import React from "react";
import { PurpleButton, FontWeight } from "../../globalStyles/emotion";
import MncsDialog from "../mncsDialog/MncsDialog";
import { LocationPhoto } from "./LocationPhoto";
import ENV from "../../constants/Environment";
import handleLogout from "../auth/Logout";

const { apiUrl } = ENV;

const Location = ({
  locationDirection,
  name,
  address,
  notes,
  roomNumber,
  photo,
}) => {
  return (
    <div>
      <div>
        <p
          style={{
            fontSize: "1rem",
            textTransform: "uppercase",
          }}
        >
          {locationDirection} Location
        </p>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-around",
        }}
      >
        <>{name === address ? null : <FontWeight>{name}</FontWeight>}</>
        <FontWeight>{address}</FontWeight>
      </div>

      {notes === null ? null : (
        <>
          <p style={{}}>{locationDirection} Location Notes:</p>{" "}
          {notes.length > 50 ? (
            <Tooltip enterDelay={500} title={notes} placement="top">
              <FontWeight>{notes.slice(0, 50)}...</FontWeight>
            </Tooltip>
          ) : (
            <FontWeight> {notes}</FontWeight>
          )}
        </>
      )}

      <div style={{ display: "flex", gap: "5px" }}>
        <p>{locationDirection} Room Number: </p>{" "}
        {roomNumber === null ? (
          <FontWeight> N/A</FontWeight>
        ) : (
          <FontWeight> {roomNumber}</FontWeight>
        )}
      </div>

      {photo && (
        <div>
          <LocationPhoto locationPhoto={photo} />
        </div>
      )}
    </div>
  );
};

const LocationInformation = ({
  startLocationName,
  startLocationAddress,
  startLocationNotes,
  startLocationPhoto,
  endLocationName,
  endLocationNotes,
  endLocationAddress,
  endLocationPhoto,
  startLocationRoomNumber,
  endLocationRoomNumber,
  rideNotes,
  mncsAnswers,
  medicalNecessityCertificationStatementId,
  mncsMode,
  rideId,
}) => {
  const [open, setOpen] = React.useState(false);
  const [isDownloading, setIsDownloading] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const renderMncsSection = () => {
    if (mncsMode === "collected_at_pickup") {
      return (
        <div>
          <FontWeight>MNCS to be collected on pickup</FontWeight>
        </div>
      );
    }
    if (mncsMode === "marked_not_required") {
      return (
        <div>
          <FontWeight>MNCS not required</FontWeight>
        </div>
      );
    }
    if (medicalNecessityCertificationStatementId) {
      return (
        <div className="display-button-flex">
          <PurpleButton onClick={handleDownloadMncs} disabled={isDownloading}>
            {isDownloading ? "Downloading..." : "Download MNCS"}
          </PurpleButton>
        </div>
      );
    }
    if (mncsAnswers.length > 0) {
      return (
        <>
          <div className="display-button-flex">
            <PurpleButton onClick={handleOpen}>
              Medical Necessity Certification Statement
            </PurpleButton>
          </div>
          <MncsDialog
            mncsAnswers={mncsAnswers}
            open={open}
            setOpen={setOpen}
            handleClose={handleClose}
          />
        </>
      );
    }
    return null;
  };

  const handleDownloadMncs = async () => {
    if (isDownloading) return;
    setIsDownloading(true);

    try {
      const token = localStorage.getItem("accessToken");
      const response = await fetch(`${apiUrl}/Rides/${rideId}/ExportMncs`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) {
        if (response.status === 401) {
          handleLogout();
        } else {
          alert("Failed to download MNCS file.");
        }
        return;
      }

      const contentDisposition = response.headers.get("Content-Disposition");
      const filename =
        contentDisposition?.match(/filename="?([^";\n]+)"?/)?.[1] || "MNCS.pdf";

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(link.href);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
      <Location
        locationDirection="Pickup"
        name={startLocationName}
        address={startLocationAddress}
        notes={startLocationNotes}
        roomNumber={startLocationRoomNumber}
        photo={startLocationPhoto}
      />

      <Location
        locationDirection="Drop-off"
        name={endLocationName}
        address={endLocationAddress}
        notes={endLocationNotes}
        roomNumber={endLocationRoomNumber}
        photo={endLocationPhoto}
      />

      <div>
        {rideNotes === null || rideNotes === "" ? null : (
          <>
            <p>Ride Notes:</p>{" "}
            {rideNotes.length > 50 ? (
              <Tooltip enterDelay={500} title={rideNotes} placement="top">
                <FontWeight>{rideNotes.slice(0, 50)}...</FontWeight>
              </Tooltip>
            ) : (
              <FontWeight> {rideNotes}</FontWeight>
            )}
          </>
        )}
        {renderMncsSection()}
      </div>
    </div>
  );
};

export default LocationInformation;
